import { HandlebarsCache } from "./HandlebarsCache";

export default function (Handlebars) {
  new HandlebarsCache(Handlebars);

  Handlebars.registerHelper("removehttp", function (str) {
    return str.replace(/^https?:\/\//, "");
  });
  Handlebars.registerHelper("i18n", function (key) {
    return i18next.t(key);
  });
  Handlebars.registerHelper("select", function (value, options) {
    var $el = $("<select />").html(options.fn(this));
    $el.find('[value="' + value + '"]').attr({ selected: "selected" });
    return $el.html();
  });

  Handlebars.registerHelper('momentTo', function(arg1, options) {
    let display_date = moment.unix(arg1);
    let todays_date = moment();
    return todays_date.to(display_date);
});

  Handlebars.registerHelper("moment", function (timestamp, arg2, options) {
    let format = "h:mma dddd - Do MMMM Y";
    if (typeof options != "undefined") {
      format = arg2;
    }
    return moment.unix(timestamp).format(format);
  });

  Handlebars.registerHelper(
    "momentFromNow",
    function (timestamp, arg2, options) {
      if (typeof options != "undefined" && arg2 == "true") {
        return moment.unix(timestamp).fromNow(arg2);
      }
      return moment.unix(timestamp).fromNow();
    }
  );

  Handlebars.registerHelper("formatTotalSeconds", function (totalSeconds) {
    var duration = moment.utc(totalSeconds * 1000);
    if (totalSeconds < 3600) {
      return duration.format("m:ss");
    } else {
      return duration.format("HH:mm:ss");
    }
  });

  Handlebars.registerHelper("ifCond", function (v1, operator, v2, options) {
    switch (operator) {
      case "==":
        return v1 == v2 ? options.fn(this) : options.inverse(this);
      case "===":
        return v1 === v2 ? options.fn(this) : options.inverse(this);
      case "!=":
        return v1 != v2 ? options.fn(this) : options.inverse(this);
      case "!==":
        return v1 !== v2 ? options.fn(this) : options.inverse(this);
      case "<":
        return v1 < v2 ? options.fn(this) : options.inverse(this);
      case "<=":
        return v1 <= v2 ? options.fn(this) : options.inverse(this);
      case ">":
        return v1 > v2 ? options.fn(this) : options.inverse(this);
      case ">=":
        return v1 >= v2 ? options.fn(this) : options.inverse(this);
      case "&&":
        return v1 && v2 ? options.fn(this) : options.inverse(this);
      case "||":
        return v1 || v2 ? options.fn(this) : options.inverse(this);
      default:
        return options.inverse(this);
    }
  });
  Handlebars.registerHelper("equals", function (arg1, arg2, options) {
    if (typeof arg1 == "undefined" && arg2 == "") {
      arg1 = "";
    }
    if (typeof arg2 == "undefined" && arg1 == "") {
      arg2 = "";
    }
    return arg1 == arg2 ? options.fn(this) : options.inverse(this);
  });
  Handlebars.registerHelper("notEquals", function (arg1, arg2, options) {
    if (typeof arg1 == "undefined" && arg2 == "") {
      arg1 = "";
    }
    if (typeof arg2 == "undefined" && arg1 == "") {
      arg2 = "";
    }
    return arg1 != arg2 ? options.fn(this) : options.inverse(this);
  });
  Handlebars.registerHelper("companyUrl", function (path, file, options) {
    return GenerateCompanyUrl(path, file, convertHash(options.hash ?? {}));
  });
  Handlebars.registerHelper("orgUrl", function (path, file, options) {
    return GenerateOrganisationUrl(path, file, convertHash(options.hash ?? {}));
  });
  Handlebars.registerHelper("concatPath", function () {
    let s = [];
    for (let i = 0; i < arguments.length; i++) {
      let a = arguments[i];
      if (!isNaN(a) || typeof a == "string") {
        s.push(a);
      }
    }
    return s.join("/");
  });
  function convertHash(hash) {
    var args = {};
    Object.keys(hash).forEach((key) => {
      var escapedKey = Handlebars.escapeExpression(key);
      var escapedValue = Handlebars.escapeExpression(hash[key]);
      args[escapedKey] = escapedValue;
    });
    return args;
  }

  Handlebars.registerHelper("toLower", function (str) {
    return str.toLowerCase();
  });
  Handlebars.registerHelper("i18nobj", function (key, obj) {
    return i18next.t(key, obj);
  });

  Handlebars.registerHelper("or", function () {
    var len = arguments.length - 1;
    var options = arguments[len];
    var val = false;
    for (var i = 0; i < len; i++) {
      if (arguments[i].length > 0) {
        val = true;
        break;
      }
    }
    return val;
  });

  Handlebars.registerHelper("breaklines", function (text) {
    text = Handlebars.Utils.escapeExpression(text);
    text = text.replace(/(\r\n|\n|\r)/gm, "<br>");
    return new Handlebars.SafeString(text);
  });

  Handlebars.registerHelper("worldwidePath", function (path) {
    return _worldwideCDNPath + path.replace(/^\//, "");
  });

  Handlebars.registerHelper("commaFormatNumber", function (value) {
    return value.toLocaleString("en-US");
  });

  //TODO: Extend this to work for plural/non-plural
  Handlebars.registerHelper(
    "timeDurationFormat",
    function (totalSeconds, hourSuffix, minuteSuffix, secondSuffix) {
      var readableString = "";
      var hours, minutes, seconds;

      hours = Math.floor(totalSeconds / 3600);
      minutes = Math.floor((totalSeconds - hours * 3600) / 60);
      seconds = Math.floor(totalSeconds - minutes * 60 - hours * 3600);

      if (hours >= 1 && hourSuffix != null) {
        readableString += hours + hourSuffix + " ";
      }

      if (minutes >= 1 && minuteSuffix != null) {
        readableString += minutes + minuteSuffix + " ";
      }

      if (seconds >= 1 && secondSuffix != null) {
        readableString += seconds + secondSuffix + " ";
      }

      return readableString;
    }
  );

  Handlebars.registerHelper("coalesce", function (a, b) {
    return a || b;
  });

  Handlebars.registerHelper("getFromCache", (function(type, key, options) {
      return options.fn(HandlebarsCache.Instance.getFromCache(type, key));
    }).bind(this));

  Handlebars.registerHelper("subtract", function (arg1, arg2) {
    return arg1 - arg2;
  });

  Handlebars.registerHelper('iter', function (context, options) {
    var ret = "";

    for (var i = 0, j = context.length; i < j; i++) {
        ret += options.fn($.extend(context[i], {position: i + 1}));
    }

    return ret;
  });
  //lookup array 
  Handlebars.registerHelper('idLookup', function(collection, id) {
      var collectionLength = collection.length;

      for (var i = 0; i < collectionLength; i++) {
          if (collection[i].id === id) {
              return collection[i];
          }

      }

      return null;
  });
  // https://gist.github.com/amitkumar/b1969e86e1379db83511
  /**
   * @param ary {Array}
   * @param max {Number} The max number of items to display from the array
   * @param [options.skip] {Number=0} Optional. Number of items to skip in the array
   */
  Handlebars.registerHelper('each_upto', function(ary, max, options) {
    if(!ary || ary.length == 0)
        return options.inverse(this);

    var result = [],
      skip = (options.hash ? (options.hash.skip ? options.hash.skip : 0) : 0),
      i = skip;

    max += skip;

    for(; i < max && i < ary.length; ++i) {
      result.push(options.fn(ary[i], { data : { itemIndex : i } } ));
    }
        
    return result.join('');
  });

  Handlebars.registerHelper('zero_format', function(a, b) { 
      if (a == 0 || typeof a === "undefined")
      {
         return b;
      }

      return a;
   });

   Handlebars.registerHelper("is_undefined", function (value, options) {
    return typeof value === 'undefined' ? options.fn(this) : options.inverse(this);
  });
  
  Handlebars.registerHelper("inc", function(value, options)
  {
      return parseInt(value) + 1;
  });
}

